
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e6b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e6b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lXjPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffbe7c7125e506e8$var$pokemonCardTpl;
module.exports.handleFavoriteClick = $ffbe7c7125e506e8$var$handleFavoriteClick;

var $cAXwu = parcelRequire("cAXwu");
const $ffbe7c7125e506e8$var$refs = {
    cardContainer: document.querySelector('.card-container')
};
// Store the current Pokemon data globally for favorites functionality
let $ffbe7c7125e506e8$var$currentPokemon = null;
function $ffbe7c7125e506e8$var$pokemonCardTpl(pokemon) {
    const { id: id, sprites: sprites, name: name, weight: weight, height: height, abilities: abilities, types: types } = pokemon;
    const abilityName = abilities.map((ab)=>ab.ability.name).join(', ');
    const favorited = (0, $cAXwu.isFavorited)(id);
    const buttonText = favorited ? "\u2605 Favorited" : "\u2606 Add to Favorites";
    const buttonClass = favorited ? 'add-to-favorites-btn favorited' : 'add-to-favorites-btn';
    return `
    <div class='card' data-pokemon-id='${id}'>
      <div class='card-img-top'>
        <img class='card-img-top-card' src='${sprites.front_default}' alt='${name}' />
      </div>
      <div class='card-body'>
        <h2 class='card-title'>Name: ${name}</h2>
        <p class='card-text'>Weight: ${weight}</p>
        <p class='card-text'>Height: ${height}</p>

        <h2 class='card-text'>Skills</h2>
        <ul class='list-group'>
          <li class='list-group-item'>${abilityName}</li>
        </ul>

        <h2 class='poke-type-label'>Type:</h2>
        <p class='card-text'>
          ${types.map((t)=>`<span class='pokemon-type'>${t.type.name}</span>`).join(' ')}
        </p>

        <button 
          class='${buttonClass}' 
          data-pokemon-id='${id}' 
          data-pokemon='${JSON.stringify(pokemon).replace(/'/g, '&apos;')}'
        >
          ${buttonText}
        </button>
      </div>
    </div>
  `;
}
function $ffbe7c7125e506e8$var$handleFavoriteClick(e) {
    const btn = e.target;
    const pokemonId = parseInt(btn.dataset.pokemonId);
    const pokemon = JSON.parse(btn.dataset.pokemon);
    if ((0, $cAXwu.isFavorited)(pokemonId)) {
        (0, $cAXwu.removeFromFavorites)(pokemonId);
        btn.textContent = "\u2606 Add to Favorites";
        btn.classList.remove('favorited');
    } else {
        (0, $cAXwu.addToFavorites)(pokemon);
        btn.textContent = "\u2605 Favorited";
        btn.classList.add('favorited');
    }
    (0, $cAXwu.updateFavoriteCount)();
}

});
parcelRegister("cAXwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addToFavorites = $92b704da29f36d38$var$addToFavorites;
module.exports.getFavorites = $92b704da29f36d38$var$getFavorites;
module.exports.hideFavoritesSection = $92b704da29f36d38$var$hideFavoritesSection;
module.exports.initFavorites = $92b704da29f36d38$var$initFavorites;
module.exports.isFavorited = $92b704da29f36d38$var$isFavorited;
module.exports.removeFromFavorites = $92b704da29f36d38$var$removeFromFavorites;
module.exports.showFavoritesSection = $92b704da29f36d38$var$showFavoritesSection;
module.exports.updateFavoriteCount = $92b704da29f36d38$var$updateFavoriteCount;
module.exports.updateFavoritesUI = $92b704da29f36d38$var$updateFavoritesUI;

var $37ouH = parcelRequire("37ouH");
// Favorites Module - GREEN Phase Implementation
// Key: 'pokemonFavorites' in localStorage
function $92b704da29f36d38$var$favoritesFilterAndSort(favorites) {
    const query = document.querySelector('.poke-input').value.trim().toLowerCase();
    const sortMode = document.querySelector('.poke_sort').value;
    const type = document.querySelector('.poke_filter').value;
    const maxWeight = Number(document.getElementById('weight-value').textContent);
    const maxHeight = Number(document.getElementById('height-value').textContent);
    let result = [
        ...favorites
    ];
    // Filtering logic (same as main)
    if (query) result = (0, $37ouH.filterByName)(result, query);
    if (type && type !== 'all') result = (0, $37ouH.filterByType)(result, type);
    result = (0, $37ouH.filterByWeight)(result, 1, maxWeight);
    result = (0, $37ouH.filterByHeight)(result, 1, maxHeight);
    // Sorting logic (same as main)
    if (sortMode === 'asc') result = (0, $37ouH.sortByNameAZ)(result);
    if (sortMode === 'desc') result = (0, $37ouH.sortByNameZA)(result);
    if (sortMode === 'id-asc') result = (0, $37ouH.sortByIdAsc)(result);
    if (sortMode === 'id-desc') result = (0, $37ouH.sortByIdDesc)(result);
    return result;
}
const $92b704da29f36d38$var$STORAGE_KEY = 'pokemonFavorites';
/**
 * Get all favorites from localStorage
 * @returns {Array} Array of favorite Pokemon objects
 */ function $92b704da29f36d38$var$getFavorites() {
    const data = localStorage.getItem($92b704da29f36d38$var$STORAGE_KEY);
    return data ? JSON.parse(data) : [];
}
/**
 * Save favorites to localStorage
 * @param {Array} favorites - Array of favorite Pokemon objects
 */ function $92b704da29f36d38$var$saveFavorites(favorites) {
    localStorage.setItem($92b704da29f36d38$var$STORAGE_KEY, JSON.stringify(favorites));
}
/**
 * Check if a Pokemon is already favorited
 * @param {number} pokemonId - Pokemon ID to check
 * @returns {boolean} True if favorited
 */ function $92b704da29f36d38$var$isFavorited(pokemonId) {
    const favorites = $92b704da29f36d38$var$getFavorites();
    return favorites.some((pokemon)=>pokemon.id === pokemonId);
}
/**
 * Add a Pokemon to favorites
 * @param {Object} pokemon - Pokemon object with id, name, sprites, etc.
 */ function $92b704da29f36d38$var$addToFavorites(pokemon) {
    if ($92b704da29f36d38$var$isFavorited(pokemon.id)) return; // Prevent duplicates
    const favorites = $92b704da29f36d38$var$getFavorites();
    const pokemonData = {
        id: pokemon.id,
        name: pokemon.name,
        sprites: pokemon.sprites,
        weight: pokemon.weight,
        height: pokemon.height,
        abilities: pokemon.abilities,
        types: pokemon.types
    };
    favorites.push(pokemonData);
    $92b704da29f36d38$var$saveFavorites(favorites);
    $92b704da29f36d38$var$updateFavoriteCount();
}
/**
 * Remove a Pokemon from favorites
 * @param {number} pokemonId - Pokemon ID to remove
 */ function $92b704da29f36d38$var$removeFromFavorites(pokemonId) {
    let favorites = $92b704da29f36d38$var$getFavorites();
    favorites = favorites.filter((pokemon)=>pokemon.id !== pokemonId);
    $92b704da29f36d38$var$saveFavorites(favorites);
    $92b704da29f36d38$var$updateFavoriteCount();
    $92b704da29f36d38$var$updateFavoritesUI();
}
/**
 * Update the favorites count badge
 */ function $92b704da29f36d38$var$updateFavoriteCount() {
    const favorites = $92b704da29f36d38$var$getFavorites();
    const badge = document.querySelector('.favorites-count, .badge');
    if (badge) {
        badge.textContent = favorites.length;
        badge.style.display = favorites.length > 0 ? 'inline-block' : 'none';
    }
}
/**
 * Render the favorites list in the favorites container
 */ function $92b704da29f36d38$var$updateFavoritesUI() {
    const container = document.querySelector('.favorites-container');
    if (!container) return;
    let favorites = $92b704da29f36d38$var$getFavorites();
    // 🔥 APPLY SORTING + FILTERING
    favorites = $92b704da29f36d38$var$favoritesFilterAndSort(favorites);
    // Always include back button and title
    const headerHTML = `
    <button class="back-to-search-btn">\u{2190} Back to Search</button>
    <h2 class="favorites-title">Your Favorite Pokemon</h2>
  `;
    if (favorites.length === 0) {
        container.innerHTML = `
      ${headerHTML}
      <div class="empty-state">
        <p>No favorites yet. Add some Pokemon to your favorites!</p>
      </div>
    `;
        $92b704da29f36d38$var$setupBackButton();
        return;
    }
    const cardsHTML = favorites.map((pokemon)=>`
      <div class="card favorite-card" data-pokemon-id="${pokemon.id}">
        <div class="card-img-top">
          <img class="card-img-top-card" src="${pokemon.sprites?.front_default || ''}" alt="${pokemon.name}" />
        </div>
        <div class="card-body">
          <h2 class="card-title">Name: ${pokemon.name}</h2>
          <p class="card-text">Weight: ${pokemon.weight || 'N/A'}</p>
          <p class="card-text">Height: ${pokemon.height || 'N/A'}</p>
          <p class="card-text">Height: ${pokemon.height || 'N/A'}</p>
          <h2 class="poke-type-label">Type:</h2>
          <p class="card-text">${(pokemon.types || []).map((t)=>`<span class='pokemon-type'>${t.type.name}</span>`).join(' ')}</p>
          <button class="remove-from-favorites-btn" data-pokemon-id="${pokemon.id}">
            Remove from Favorites
          </button>
        </div>
      </div>
    `).join('');
    container.innerHTML = `
    ${headerHTML}
    <div class="favorites-container">${cardsHTML}</div>
  `;
    // Add event listeners to remove buttons
    container.querySelectorAll('.remove-from-favorites-btn').forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
            const pokemonId = parseInt(e.target.dataset.pokemonId);
            $92b704da29f36d38$var$removeFromFavorites(pokemonId);
        });
    });
    $92b704da29f36d38$var$setupBackButton();
}
/**
 * Setup back button event listener
 */ function $92b704da29f36d38$var$setupBackButton() {
    const backBtn = document.querySelector('.back-to-search-btn');
    if (backBtn) backBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        $92b704da29f36d38$var$hideFavoritesSection();
    });
}
/**
 * Toggle favorites section visibility
 */ function $92b704da29f36d38$var$showFavoritesSection() {
    const favoritesSection = document.querySelector('.favorites-section');
    const mainContent = document.querySelector('.card-container');
    const formBox = document.querySelector('.poke-form_box');
    const openaiSection = document.querySelector('.openai-section');
    const teamSection = document.querySelector('.team-section');
    if (favoritesSection) {
        favoritesSection.style.display = 'block';
        favoritesSection.classList.add('favorites-container');
    }
    if (mainContent) mainContent.style.display = 'none';
    if (formBox) formBox.style.display = 'none';
    if (openaiSection) openaiSection.style.display = 'none';
    if (teamSection) teamSection.style.display = 'none';
    $92b704da29f36d38$var$updateFavoritesUI();
}
/**
 * Hide favorites section and show main content
 */ function $92b704da29f36d38$var$hideFavoritesSection() {
    const favoritesSection = document.querySelector('.favorites-section');
    const mainContent = document.querySelector('.card-container');
    const formBox = document.querySelector('.poke-form_box');
    if (favoritesSection) favoritesSection.style.display = 'none';
    if (mainContent) mainContent.style.display = 'flex';
    if (formBox) formBox.style.display = 'block';
    // Sync favorite buttons in search results to reflect current favorites state
    $92b704da29f36d38$var$syncFavoriteButtons();
}
/**
 * Sync all favorite buttons in search results to reflect current favorites state
 */ function $92b704da29f36d38$var$syncFavoriteButtons() {
    const buttons = document.querySelectorAll('.card-container .add-to-favorites-btn');
    buttons.forEach((btn)=>{
        const pokemonId = parseInt(btn.dataset.pokemonId);
        if ($92b704da29f36d38$var$isFavorited(pokemonId)) {
            btn.textContent = "\u2605 Favorited";
            btn.classList.add('favorited');
        } else {
            btn.textContent = "\u2606 Add to Favorites";
            btn.classList.remove('favorited');
        }
    });
}
/**
 * Initialize favorites functionality on page load
 */ function $92b704da29f36d38$var$initFavorites() {
    $92b704da29f36d38$var$updateFavoriteCount();
    // Set up favorites navigation click handler
    const favoritesLink = document.querySelector('.favorites-link, .favorites-btn');
    if (favoritesLink) favoritesLink.addEventListener('click', (e)=>{
        e.preventDefault();
        $92b704da29f36d38$var$showFavoritesSection();
    });
    // Set up back button handler
    const backBtn = document.querySelector('.back-to-search-btn');
    if (backBtn) backBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        $92b704da29f36d38$var$hideFavoritesSection();
    });
}
// Make functions available globally for button onclick handlers
if (typeof window !== 'undefined') {
    window.addToFavorites = $92b704da29f36d38$var$addToFavorites;
    window.removeFromFavorites = $92b704da29f36d38$var$removeFromFavorites;
    window.getFavorites = $92b704da29f36d38$var$getFavorites;
    window.isFavorited = $92b704da29f36d38$var$isFavorited;
    window.updateFavoritesUI = $92b704da29f36d38$var$updateFavoritesUI;
    window.updateFavoriteCount = $92b704da29f36d38$var$updateFavoriteCount;
}
// CommonJS exports for Jest testing
if (module.exports) module.exports = {
    getFavorites: $92b704da29f36d38$var$getFavorites,
    isFavorited: $92b704da29f36d38$var$isFavorited,
    addToFavorites: $92b704da29f36d38$var$addToFavorites,
    removeFromFavorites: $92b704da29f36d38$var$removeFromFavorites,
    updateFavoriteCount: $92b704da29f36d38$var$updateFavoriteCount,
    updateFavoritesUI: $92b704da29f36d38$var$updateFavoritesUI,
    showFavoritesSection: $92b704da29f36d38$var$showFavoritesSection,
    hideFavoritesSection: $92b704da29f36d38$var$hideFavoritesSection,
    initFavorites: $92b704da29f36d38$var$initFavorites
};

});
parcelRegister("37ouH", function(module, exports) {
"use strict";
function $2455068dda3ce37b$var$filterByName(pokemonArr, query) {
    if (!query) return pokemonArr;
    const lowerQuery = query.toLowerCase();
    const isNumeric = /^\d+$/.test(query);
    return pokemonArr.filter((pokemon)=>{
        // Match by ID if query is numeric
        if (isNumeric && pokemon.id === parseInt(query)) return true;
        // Match by name (starts with query)
        return pokemon.name.toLowerCase().startsWith(lowerQuery);
    });
}
function $2455068dda3ce37b$var$sortByNameAZ(arr) {
    return [
        ...arr
    ].sort((a, b)=>a.name.localeCompare(b.name));
}
function $2455068dda3ce37b$var$sortByNameZA(arr) {
    return [
        ...arr
    ].sort((a, b)=>b.name.localeCompare(a.name));
}
function $2455068dda3ce37b$var$sortByIdAsc(arr) {
    return [
        ...arr
    ].sort((a, b)=>a.id - b.id);
}
function $2455068dda3ce37b$var$sortByIdDesc(arr) {
    return [
        ...arr
    ].sort((a, b)=>b.id - a.id);
}
function $2455068dda3ce37b$var$filterByType(arr, type) {
    const wanted = Array.isArray(type) ? type : [
        type
    ];
    return arr.filter((p)=>{
        // If types is undefined, include the Pokemon (don't filter it out)
        if (!p.types || !Array.isArray(p.types)) return true;
        return p.types.some((t)=>wanted.includes(t.type.name));
    });
}
function $2455068dda3ce37b$var$filterByWeight(arr, min, max) {
    return arr.filter((p)=>{
        // If weight is undefined, include the Pokemon (don't filter it out)
        if (p.weight === undefined || p.weight === null) return true;
        return p.weight >= min && p.weight <= max;
    });
}
function $2455068dda3ce37b$var$filterByHeight(arr, min, max) {
    return arr.filter((p)=>{
        // If height is undefined, include the Pokemon (don't filter it out)
        if (p.height === undefined || p.height === null) return true;
        return p.height >= min && p.height <= max;
    });
}
module.exports = {
    filterByName: $2455068dda3ce37b$var$filterByName,
    sortByNameAZ: $2455068dda3ce37b$var$sortByNameAZ,
    sortByNameZA: $2455068dda3ce37b$var$sortByNameZA,
    sortByIdAsc: $2455068dda3ce37b$var$sortByIdAsc,
    sortByIdDesc: $2455068dda3ce37b$var$sortByIdDesc,
    filterByType: $2455068dda3ce37b$var$filterByType,
    filterByWeight: $2455068dda3ce37b$var$filterByWeight,
    filterByHeight: $2455068dda3ce37b$var$filterByHeight
};

});



parcelRegister("7me8F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $55b58e231f028392$var$BASE_URL = `https://pokeapi.co/api/v2`;
var $55b58e231f028392$var$_default = module.exports.default = {
    fetchPokemon (nameID) {
        return fetch(`${$55b58e231f028392$var$BASE_URL}/pokemon/${nameID}`).then((res)=>{
            if (!res.ok) throw new Error('Pokemon not found');
            return res.json();
        });
    },
    fetchAll (limit = 20, offset = 0) {
        return fetch(`${$55b58e231f028392$var$BASE_URL}/pokemon?limit=${limit}&offset=${offset}`).then((res)=>{
            if (!res.ok) throw new Error("Failed to fetch Pok\xe9mon");
            return res.json();
        });
    }
};

});

"use strict";

var $7347181ddf74d6b0$var$_markup = $7347181ddf74d6b0$var$_interopRequireWildcard((parcelRequire("lXjPc")));

var $7347181ddf74d6b0$var$_apiService = $7347181ddf74d6b0$var$_interopRequireDefault((parcelRequire("7me8F")));

var $cAXwu = parcelRequire("cAXwu");
var $b3100e4e7185cc4d$exports = {};
"use strict";
Object.defineProperty($b3100e4e7185cc4d$exports, "__esModule", {
    value: true
});
$b3100e4e7185cc4d$exports.hideOpenAISection = $b3100e4e7185cc4d$var$hideOpenAISection;
$b3100e4e7185cc4d$exports.initOpenAI = $b3100e4e7185cc4d$var$initOpenAI;
$b3100e4e7185cc4d$exports.parseAIResult = $b3100e4e7185cc4d$var$parseAIResult;
$b3100e4e7185cc4d$exports.showOpenAISection = $b3100e4e7185cc4d$var$showOpenAISection;

var $b3100e4e7185cc4d$var$_apiService = $b3100e4e7185cc4d$var$_interopRequireDefault((parcelRequire("7me8F")));
function $b3100e4e7185cc4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $b3100e4e7185cc4d$var$setupBackButton() {
    const backBtn = document.querySelector('.openai-section .back-to-search-btn');
    if (backBtn) backBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        $b3100e4e7185cc4d$var$hideOpenAISection();
    });
}
function $b3100e4e7185cc4d$var$setupOpenAIUI() {
    const openaiSection = document.querySelector('.openai-section');
    if (!openaiSection) return;
    // Check if header already exists to prevent duplicates
    if (openaiSection.querySelector('.back-to-search-btn')) return;
    // Add back button and title at the beginning of openai-section (direct children)
    const headerHTML = `
        <button class="back-to-search-btn">\u{2190} Back to Search</button>
        <h2 class="openai-title">Ask ChatGPT</h2>
    `;
    const openaiBox = openaiSection.querySelector('.openai-box');
    if (openaiBox) openaiBox.insertAdjacentHTML('beforebegin', headerHTML);
    else openaiSection.insertAdjacentHTML('afterbegin', headerHTML);
    $b3100e4e7185cc4d$var$setupBackButton();
}
/**
 * Show OpenAI section and hide main content
 */ function $b3100e4e7185cc4d$var$showOpenAISection() {
    const openaiSection = document.querySelector('.openai-section');
    const mainContent = document.querySelector('.card-container');
    const formBox = document.querySelector('.poke-form_box');
    const pokeFiltSort = document.querySelector('.poke-filt_sort');
    const moreBtn = document.querySelector('.more_btn');
    const favoritesSection = document.querySelector('.favorites-section');
    const teamSection = document.querySelector('.team-section');
    if (openaiSection) openaiSection.style.display = 'block';
    if (mainContent) mainContent.style.display = 'none';
    if (formBox) formBox.style.display = 'none';
    if (pokeFiltSort) pokeFiltSort.style.display = 'none';
    if (moreBtn) moreBtn.style.display = 'none';
    if (favoritesSection) favoritesSection.style.display = 'none';
    if (teamSection) teamSection.style.display = 'none';
    $b3100e4e7185cc4d$var$setupOpenAIUI();
}
/**
 * Hide OpenAI section and show main content
 */ function $b3100e4e7185cc4d$var$hideOpenAISection() {
    const openaiSection = document.querySelector('.openai-section');
    const mainContent = document.querySelector('.card-container');
    const formBox = document.querySelector('.poke-form_box');
    const pokeFiltSort = document.querySelector('.poke-filt_sort');
    const moreBtn = document.querySelector('.more_btn');
    if (openaiSection) openaiSection.style.display = 'none';
    if (mainContent) mainContent.style.display = 'flex';
    if (formBox) formBox.style.display = 'block';
    if (pokeFiltSort) pokeFiltSort.style.display = 'flex';
    if (moreBtn) moreBtn.style.display = 'block';
}
function $b3100e4e7185cc4d$var$handleAIQuery() {
    const aiInput = document.getElementById('aiinput');
    const aiResponse = document.querySelector('.openai-response');
    const aiResponseTitle = document.querySelector('.openai-response-title');
    if (aiInput) aiInput.addEventListener('keydown', async (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            const userInput = aiInput.value.trim();
            const prompt = `Return a list of Pok\xe9mon that are best for the following task. The format should be, one line: pokemon: reason, second line: pokemon: reason, ... and so on. The task is: ${userInput}. Gather a team of capable Pok\xe9mon for this task. And give extended reasons for each choice. Example: "
Alakazam: Alakazam has high intelligence and psychic abilities, allowing it to quickly analyze and strategize the most efficient way to clean a space. Its psychic powers also allow it to move objects with ease, making it helpful for heavy lifting during cleaning.

Blissey: Blissey's nurturing nature and ability to heal others make it a great addition to a cleaning team. It can provide emotional support to other Pok\xe9mon during the cleaning process and tend to any injuries that may occur.

Lucario: Lucario's fighting abilities make it very agile and proficient at cleaning hard to reach areas. Its steel typing also makes it durable and able to handle tough cleaning tasks."`;
            console.log('Prompt:', prompt); // Log the prompt value
            if (!userInput) return;
            if (aiResponse) aiResponse.textContent = 'Thinking...';
            if (aiResponseTitle) aiResponseTitle.textContent = `The best Pokemon for "${userInput}" is...`;
            try {
                const res = await fetch('https://poke-api-server.vercel.app/api/openai', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        prompt: prompt
                    })
                });
                if (!res.ok) {
                    const text = await res.text();
                    if (aiResponse) aiResponse.textContent = `Error: ${text}`;
                    return;
                }
                const data = await res.json();
                console.log('OpenAI Server Response:', data);
                if (aiResponse) {
                    // Parse the new format: each line is "PokemonName: description"
                    const pokemonEntries = $b3100e4e7185cc4d$var$parseAIResult(data.result);
                    const list = document.createElement('ul');
                    list.className = 'pokemon-list';
                    pokemonEntries.forEach((entry)=>{
                        const listItem = document.createElement('li');
                        const textDiv = document.createElement('div');
                        textDiv.innerHTML = `<strong>${entry.name}:</strong> ${entry.reason}`;
                        listItem.appendChild(textDiv);
                        $b3100e4e7185cc4d$var$_apiService.default.fetchPokemon(entry.name.toLowerCase()).then((pokemonData)=>{
                            if (pokemonData && pokemonData.sprites && pokemonData.sprites.front_default) {
                                const imageDiv = document.createElement('div');
                                imageDiv.classList.add('pokemon-image');
                                const img = document.createElement('img');
                                img.src = pokemonData.sprites.front_default;
                                img.alt = entry.name;
                                img.classList.add('pokemon-image-tag');
                                imageDiv.appendChild(img);
                                listItem.appendChild(imageDiv);
                            } else listItem.remove();
                        }).catch((error)=>{
                            console.error(`Error fetching data for ${entry.name}:`, error);
                            listItem.remove();
                        });
                        list.appendChild(listItem);
                    });
                    console.log('Pokemon entries:', pokemonEntries);
                    aiResponse.innerHTML = '';
                    aiResponse.appendChild(list);
                }
            } catch (err) {
                if (aiResponse) aiResponse.textContent = `Network error: ${err.message}`;
            } finally{
                aiInput.value = '';
            }
        }
    });
}
function $b3100e4e7185cc4d$var$initOpenAI() {
    const openaiLink = document.querySelector('.openai-link');
    if (openaiLink) openaiLink.addEventListener('click', (e)=>{
        e.preventDefault();
        $b3100e4e7185cc4d$var$showOpenAISection();
    });
    $b3100e4e7185cc4d$var$handleAIQuery();
}
/**
 * Parses the OpenAI response string into structured data.
 * @param {string} text - The raw text response from OpenAI.
 * @returns {Array<{name: string, reason: string}>} Array of pokemon objects.
 */ function $b3100e4e7185cc4d$var$parseAIResult(text) {
    if (!text) return [];
    const lines = text.split('\n').filter((line)=>line.trim().length > 0);
    const pokemonEntries = [];
    lines.forEach((line)=>{
        const colonIndex = line.indexOf(':');
        if (colonIndex > 0) {
            const pokemonName = line.substring(0, colonIndex).trim();
            const reason = line.substring(colonIndex + 1).trim();
            pokemonEntries.push({
                name: pokemonName,
                reason: reason
            });
        }
    });
    return pokemonEntries;
}



var $37ouH = parcelRequire("37ouH");
function $7347181ddf74d6b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $7347181ddf74d6b0$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($7347181ddf74d6b0$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
// import pokemonCardTpl from '../partials/markup';
const $7347181ddf74d6b0$var$refs = {
    cardContainer: document.querySelector('.card-container'),
    searchForm: document.querySelector('.poke_form'),
    sortSelect: document.querySelector('.poke_sort'),
    typeFilter: document.querySelector('.poke_filter'),
    searchInput: document.querySelector('.poke-input'),
    moreBtn: document.querySelector('.more_btn'),
    weightRange: document.querySelector('.poke_weights_range'),
    heightRange: document.querySelector('.poke_heights_range'),
    weightVal: document.getElementById('weight-value'),
    heightVal: document.getElementById('height-value')
};
let $7347181ddf74d6b0$var$allPokemons = [];
let $7347181ddf74d6b0$var$limit = 30;
let $7347181ddf74d6b0$var$offset = 0;
let $7347181ddf74d6b0$var$totalCount = 0;
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $cAXwu.initFavorites)();
    (0, $b3100e4e7185cc4d$exports.initOpenAI)();
    $7347181ddf74d6b0$var$refs.moreBtn.addEventListener('click', $7347181ddf74d6b0$var$morePokemons);
    $7347181ddf74d6b0$var$refs.searchInput.addEventListener('input', ()=>{
        $7347181ddf74d6b0$var$filterAndSort();
        $7347181ddf74d6b0$var$refreshIfFavoritesPage();
    });
    $7347181ddf74d6b0$var$refs.searchForm.addEventListener('submit', $7347181ddf74d6b0$var$onSearch);
    $7347181ddf74d6b0$var$refs.sortSelect.addEventListener('change', ()=>{
        $7347181ddf74d6b0$var$filterAndSort();
        $7347181ddf74d6b0$var$refreshIfFavoritesPage();
    });
    $7347181ddf74d6b0$var$refs.typeFilter.addEventListener('change', ()=>{
        $7347181ddf74d6b0$var$filterAndSort();
        $7347181ddf74d6b0$var$refreshIfFavoritesPage();
    });
    $7347181ddf74d6b0$var$refs.weightRange.addEventListener('input', ()=>{
        $7347181ddf74d6b0$var$refs.weightVal.textContent = $7347181ddf74d6b0$var$refs.weightRange.value;
        $7347181ddf74d6b0$var$filterAndSort();
        $7347181ddf74d6b0$var$refreshIfFavoritesPage();
    });
    $7347181ddf74d6b0$var$refs.heightRange.addEventListener('input', ()=>{
        $7347181ddf74d6b0$var$refs.heightVal.textContent = $7347181ddf74d6b0$var$refs.heightRange.value;
        $7347181ddf74d6b0$var$filterAndSort();
        $7347181ddf74d6b0$var$refreshIfFavoritesPage();
    });
    $7347181ddf74d6b0$var$loadAll();
});
// Initialize favorites functionality on page load
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $cAXwu.initFavorites)();
});
$7347181ddf74d6b0$var$refs.searchForm.addEventListener('submit', $7347181ddf74d6b0$var$onSearch);
function $7347181ddf74d6b0$var$loadAll() {
    $7347181ddf74d6b0$var$fetchBatch().then(()=>{
        $7347181ddf74d6b0$var$filterAndSort();
    });
}
function $7347181ddf74d6b0$var$refreshIfFavoritesPage() {
    const favSection = document.querySelector('.favorites-section');
    if (favSection && favSection.style.display === 'block') updateFavoritesUI();
}
function $7347181ddf74d6b0$var$fetchBatch() {
    return $7347181ddf74d6b0$var$_apiService.default.fetchAll($7347181ddf74d6b0$var$limit, $7347181ddf74d6b0$var$offset).then((data)=>{
        $7347181ddf74d6b0$var$totalCount = data.count;
        return Promise.all(data.results.map((p)=>fetch(p.url).then((res)=>res.json())));
    }).then((pokemonArr)=>{
        $7347181ddf74d6b0$var$offset += $7347181ddf74d6b0$var$limit;
        $7347181ddf74d6b0$var$allPokemons = [
            ...$7347181ddf74d6b0$var$allPokemons,
            ...pokemonArr
        ];
        return pokemonArr;
    }).catch((err)=>console.error(err));
}
function $7347181ddf74d6b0$var$renderPokemonList(pokemonArray, append = false) {
    if (!append) $7347181ddf74d6b0$var$refs.cardContainer.innerHTML = '';
    const markup = pokemonArray.map((p)=>(0, $7347181ddf74d6b0$var$_markup.default)(p)).join('');
    $7347181ddf74d6b0$var$refs.cardContainer.insertAdjacentHTML('beforeend', markup);
    $7347181ddf74d6b0$var$refs.cardContainer.querySelectorAll('.add-to-favorites-btn').forEach((btn)=>btn.addEventListener('click', $7347181ddf74d6b0$var$_markup.handleFavoriteClick));
}
function $7347181ddf74d6b0$var$onSearch(e) {
    e.preventDefault();
    $7347181ddf74d6b0$var$filterAndSort();
    // Hide favorites section when searching
    (0, $cAXwu.hideFavoritesSection)();
}
function $7347181ddf74d6b0$var$filterAndSort() {
    const query = $7347181ddf74d6b0$var$refs.searchInput.value.trim().toLowerCase();
    let result = $7347181ddf74d6b0$var$allPokemons;
    if (query) result = (0, $37ouH.filterByName)(result, query);
    const selectedType = $7347181ddf74d6b0$var$refs.typeFilter.value;
    if (selectedType && selectedType !== 'all') result = (0, $37ouH.filterByType)(result, selectedType);
    const maxWeight = Number($7347181ddf74d6b0$var$refs.weightRange.value);
    result = (0, $37ouH.filterByWeight)(result, 1, maxWeight);
    const maxHeight = Number($7347181ddf74d6b0$var$refs.heightRange.value);
    result = (0, $37ouH.filterByHeight)(result, 1, maxHeight);
    const mode = $7347181ddf74d6b0$var$refs.sortSelect.value;
    if (mode === 'asc') result = (0, $37ouH.sortByNameAZ)(result);
    if (mode === 'desc') result = (0, $37ouH.sortByNameZA)(result);
    if (mode === 'id-asc') result = (0, $37ouH.sortByIdAsc)(result);
    if (mode === 'id-desc') result = (0, $37ouH.sortByIdDesc)(result);
    $7347181ddf74d6b0$var$renderPokemonList(result);
}
function $7347181ddf74d6b0$var$morePokemons() {
    if ($7347181ddf74d6b0$var$offset >= $7347181ddf74d6b0$var$totalCount) {
        alert("No more Pok\xe9mons to load!");
        return;
    }
    $7347181ddf74d6b0$var$fetchBatch().then((newBatch)=>{
        $7347181ddf74d6b0$var$renderPokemonList(newBatch, true);
    });
}


//# sourceMappingURL=pokeApi.d27fd476.js.map
